<template>
  <q-search
    v-model="searchQuery"
    inverted
    color="white-4"
    placeholder="press Enter ↵ to search"
    @keyup.enter.native="onEnter"
  >
    <q-autocomplete
      ref="autocompleteRef"
      :min-characters="2"
      :max-results="20"
      @search="runSearch"
      @selected="itemSelected"
    />
  </q-search>
</template>

<script>
import { ref } from '@vue/composition-api';
import { search } from '@/utils/SearchUtil';

export default {
  name: 'WideSearch',
  setup(props, context) {
    const searchQuery = ref('');
    const isEnterTriggered = ref(false);
    const autocompleteRef = ref(null);

    return {
      searchQuery,
      autocompleteRef,
      runSearch,
      itemSelected,
      onEnter,
    };

    async function runSearch(query, done) {
      const compact = (query || '').replace(/\s/g, '');

      // Check if Enter was pressed and consume the flag immediately
      const shouldRun = isEnterTriggered.value;

      // Only run search if Enter was pressed and query is valid
      if (!shouldRun || compact.length < 2) {
        done([]);
        return;
      }

      // Reset the flag after checking but before the async search
      isEnterTriggered.value = false;

      const items = await search(query, 'wide');
      done(items);
    }
    function itemSelected(item, navigateWithKeyboardArrows) {
      if (navigateWithKeyboardArrows) {
        return;
      }

      const route = item.handler(item.data);

      if (route) {
        context.root.$router.push(route);
      }

      context.emit('selected', item);

      searchQuery.value = '';
    }
    function onEnter() {
      const compact = (searchQuery.value || '').replace(/\s/g, '');

      // Only trigger if query is valid
      if (compact.length < 2) {
        return;
      }

      isEnterTriggered.value = true;
      if (autocompleteRef.value) {
        autocompleteRef.value.trigger();
      }
    }
  },
};
</script>
